module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/drjose-800.c6ae3f5519bad4a2.jpg"+" 800w",
        images: [{path: "https://static.sniffspot.com/packs/img/drjose-800.c6ae3f5519bad4a2.jpg",width: 800,height: 533}],
        src: "https://static.sniffspot.com/packs/img/drjose-800.c6ae3f5519bad4a2.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/drjose-800.c6ae3f5519bad4a2.jpg"},
        
        width: 800,
        height: 533
      }